import { Box, Typography } from '@mui/material'
import moment from 'moment'
import { useEffect, useState } from 'react'

const LastTransaction = () => {
  const [bkgDetails, setBkgDetails] = useState({})
  useEffect(() => {
    let parseData = JSON.parse(sessionStorage.getItem('lastBooking') || '{}')
    setBkgDetails(parseData)
  }, [sessionStorage.getItem('lastBooking')])

  const columnDef = [
    { name: 'PNR', value: bkgDetails?.BookingID || '' },
    { name: 'Ticket No.', value: bkgDetails?.TicketNo || '' },
    { name: 'Seat No.', value: bkgDetails?.SeatNos || '' },
    { name: 'Transaction Type', value: bkgDetails.BookingType === 'AC' ? 'Confirm' : 'Phone' },
    { name: 'Route', value: bkgDetails?.RouteName || '' },
    { name: 'Journey Date', value: moment(bkgDetails?.JourneyDate).format("ddd, DD-MMM-YYYY") },
    { name: 'PAX Name', value: bkgDetails?.PassengerName || '' },
    { name: 'Price', value: bkgDetails?.TotalFare || 0 },
    { name: 'Payment Mode', value: bkgDetails?.paymentMode || '' },
  ]

  return (
    <Box className='details_Section'>
      {columnDef.map((obj) => (
        <Box className='details_list'>
          <Typography sx={{ width: '30%' }}>{obj.name}</Typography>
          <Typography>:</Typography>
          <Typography sx={{ width: '55%' }}>{obj.value}</Typography>
        </Box>
      ))}
    </Box>
  )
}

export default LastTransaction